import { render } from "./TopNav.vue?vue&type=template&id=089e4bdd&scoped=true"
const script = {}

import "./TopNav.vue?vue&type=style&index=0&id=089e4bdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089e4bdd"]])

export default __exports__